import React, { useEffect, useRef, useState } from 'react';
import { InputMask } from 'primereact/inputmask';

import { InputDateProps } from './InputDateProps'
import { AutocompleteValues, InputModes } from 'models/Form/FieldsModels'
import analyticsService from 'service/AnalyticsService/AnalyticsService'
import { AnalyticsActionTypes } from 'service/AnalyticsService/AnalyticsServiceModels'

const InputDate = React.memo((props: InputDateProps) => {
   const PrimeInputMask = InputMask as any; // Hack - inaczej build na TeamCity nie przejdzie

   const mask = "99/99/9999" // Maska nie jest przekazywana przez propsy (nie jest zapisana w definicji pola) ponieważ jest statyczna - wspólna dla każdej kontrolki tego typu w aplikacji
   const maskPlaceholder = "DD/MM/RRRR" 
   const { field, isFirstFill, handleSetIsFieldFirstFill  } = props
   const [value, setValue] = useState<string>(props.value as string)
   const hasPageBeenRendered = useRef(false)

   const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if(field.parser !== undefined){
         setValue(field.parser(e.target.value))
      }
      else {
         setValue(e.target.value)
      }
   }

   const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      if (isFirstFill && value.length > 0) { // Jeśli pole jest wypełnione po raz pierwszy oraz posiada jakąkolwiek wartość wysyłamy zdarzenie analityczne do bazy
         analyticsService.sendAnalyticAction(field.label, AnalyticsActionTypes.FieldFilledActionId)
         handleSetIsFieldFirstFill(field.name)
      }
      else if (!isFirstFill) { // Jeśli pole BYŁO JUŻ WYPEŁNIONE (AKTUALIZACJA POLA) - w tym przypadku pole nie musi posiadać wartości - użytkownik mógł zaktualizować na pustą wartość
         analyticsService.sendAnalyticAction(field.label, AnalyticsActionTypes.FieldUpdateActionId)
      }

      const currentInputValue = e.target.value
      props.handleValidateField(field.name, currentInputValue, field.validation)
      props.field.onBlurHandler && props.field.onBlurHandler(currentInputValue)
   }

   useEffect(() => { //Debounce input
      const timeoutId = setTimeout(() => {
         if(hasPageBeenRendered.current){ //Pierwsze błedy walidacyjne wyświetlamy dopiero gdy użytkownik zacznie uzupełniać kontrolki
            props.handleSaveInputValueToState(field.name, value, field.validation)
            props.handleValidateField(field.name, value, field.validation)
            return
         }

         hasPageBeenRendered.current = true // Pierwszy render strony - nie chcemy od razu wyświetlać wszystkich błędów walidacyjnych
      }, props.debounceTime)

      return () => clearTimeout(timeoutId)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, hasPageBeenRendered]);

   return (
     <>
         <PrimeInputMask
            id={field.name}
            name={field.name}
            mask={mask} 
            slotChar={maskPlaceholder}
            autoClear={false}
            value={value}
            type="text"
            placeholder={field.placeholder}
            autoComplete={field.browserAutocomplete ?? AutocompleteValues.On}
            inputMode={field.inputMode ?? InputModes.numeric}
            maxLength={!field.mask ? field.maxLength : undefined} //Jeśli jest maska ona określa ile znaków można wpisać w kontrolkę. Jeśli nie ma maski i nie ma "maxLength" nie ma limitu wpisywanych znaków
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(e)}
            onBlur={(e: React.FocusEvent<HTMLInputElement>) => handleOnBlur(e)}
         />
     </>
   );
 
})

export default InputDate;